import type { Elemental, ElementalType, OwnershipInformation } from '~~/src/types/elemental'

interface ProductContext {
  elemental: Ref<Elemental | null | undefined>
  type: ElementalTypeEnum
  ownership: Ref<OwnershipInformation | null | undefined>
  isOwner: Ref<boolean>
  elementalType: ComputedRef<ElementalType | undefined>
  isLoading: ComputedRef<boolean>
}
const sym = Symbol('ProductContext') as InjectionKey<ProductContext>

export function useElement() {
  const context = inject(sym)
  if (!context)
    throw new Error('useElement must be used within a provideElement')
  return context
}

export function useElementSafe() {
  const context = inject(sym, null)
  return context
}

export function provideElement(context: ProductContext) {
  provide(sym, context)
}
